import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import swal from "sweetalert2";
import { ChatService } from '../chat.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-server-status',
  templateUrl: './server-status.component.html',
  styleUrls: ['./server-status.component.css']
})
export class ServerStatusComponent implements OnInit, OnDestroy {
  process: any;
  isLoading = false;
  centralConn = 0;
  scoreConn = 0;
  private centralSubO: Subscription;
  private scoreSubO: Subscription;
  constructor(private userService: UserService, private chatService: ChatService) { }

  ngOnInit() {
    this.isLoading = true;
    this.userService.getAllServerProcess().subscribe(response => {
      this.isLoading = false;
      if (response['status'] == '1') {
        if (response['data'] != 'null' && response['data'] != null) {
          this.process = this.jsonToArray(response['data']);
        }
        else {
          this.process = [];
        }
        //console.log(this.process);
      }
      else {
        this.process = [];
      }
      this.chatService.setCC();
      this.chatService.getCC();
      this.centralSubO = this.chatService.getUpdateCentralListner().subscribe((resp) => {
        this.centralConn = resp.centralCounter['numClients'];
      });

      this.chatService.setSC();
      this.chatService.getSC();
      this.scoreSubO = this.chatService.getUpdateScoreListner().subscribe((resp) => {
        this.scoreConn = resp.scoreCounter['numClients'];
      });
    }, error => {
      this.isLoading = false;
      this.msgFailure();
    });
  }

  msgFailure() {
    swal.fire({
      icon: 'error',
      title: 'Something Went Wrong!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  jsonToArray(json_data) {
    var result = [];
    Object.keys(json_data).map((item, index) => {
      result.push({ type: item, data: JSON.parse(json_data[item]) });
    })
    return result;
  }

  ngOnDestroy() {
    //this.chatService.destorySocket();
    if (this.centralSubO) {
      this.centralSubO.unsubscribe();
    }

    if (this.scoreSubO) {
      this.scoreSubO.unsubscribe();
    }
  }
}